import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { api, img, list } from "@/lib/api";
import { Eyebrow, Reveal } from "@/components/site/Reveal";

const Stars = ({ n }) => (
  <span className="flex gap-0.5" data-testid="review-stars">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`h-4 w-4 ${i <= n ? "fill-[#d8b4fe] text-[#d8b4fe]" : "text-[#3b1d63]"}`} />
    ))}
  </span>
);

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(list(r))).catch(() => setReviews([]));
  }, []);
  return (
    <div className="mx-auto max-w-[1100px] px-5 pb-32 pt-32 md:px-10 md:pt-40" data-testid="reviews-page">
      <Reveal>
        <Eyebrow>Reviews</Eyebrow>
        <h1 className="font-display mt-5 text-5xl leading-[0.95] text-[#f3eefc] md:text-7xl">Straight from the <span className="italic text-[#d8b4fe]">happy homes.</span></h1>
      </Reveal>
      {!reviews.length ? (
        <p className="py-24 text-center text-[#cbbbe6]" data-testid="reviews-empty">No reviews yet — after your first order arrives, share how it fits!</p>
      ) : (
        <ul className="mt-14 grid gap-6 md:grid-cols-2">
          {reviews.map((r, i) => (
            <Reveal key={r.id} delay={(i % 2) * 0.08}>
              <li className="chamfer border border-[#281245] bg-[#0b0514] p-6 md:p-8" data-testid={`review-card-${r.id}`}>
                <div className="flex items-center gap-4">
                  <Link to={`/item/${r.product_id}`} className="shrink-0" data-testid={`review-item-link-${r.id}`}>
                    <img src={img(r.product_image)} alt={r.product_title} className="h-16 w-14 object-cover" />
                  </Link>
                  <div className="min-w-0">
                    <Link to={`/item/${r.product_id}`} className="block truncate text-sm text-[#f3eefc] hover:text-[#d8b4fe]">{r.product_title}</Link>
                    <div className="mt-1.5 flex items-center gap-3">
                      <Stars n={r.rating} />
                      <span className="font-mono-j text-xs text-[#a78bce]">{new Date(r.created_at).toLocaleDateString("en-CA")}</span>
                    </div>
                  </div>
                </div>
                {r.text && <p className="mt-4 text-[#cbbbe6]">“{r.text}”</p>}
                {r.photos?.length > 0 && (
                  <div className={`mt-4 grid gap-2 ${r.photos.length > 1 ? "grid-cols-2" : "grid-cols-1"}`}>
                    {r.photos.map((p, k) => <img key={k} src={img(p)} alt="" className="h-48 w-full object-cover" data-testid={`review-photo-${k}`} />)}
                  </div>
                )}
                <p className="font-mono-j mt-4 text-xs uppercase tracking-[0.25em] text-[#a78bce]">— {r.name}</p>
              </li>
            </Reveal>
          ))}
        </ul>
      )}
    </div>
  );
}
